import React, { useState, useEffect } from 'react';
import './Header.css';
import Typewriter from './Typewriter';
import NeuralNetworkBackground from './NeuralNetworkBackground'; // Import background

const Header = React.forwardRef(({ inView }, ref) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showHeaderCursor, setShowHeaderCursor] = useState(false); // New state

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    handleScroll(); // Set initial state
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHeaderCursor(true);
    }, 2000); // Show cursor after 2 seconds
    return () => clearTimeout(timer);
  }, []);

  return (
    <header id="header" ref={ref} className={`header ${isScrolled ? 'scrolled' : ''}`}> {/* Add id and ref */}
      <NeuralNetworkBackground className="header-neural-background" mobileNodes={6} webNodes={8} /> {/* Render background with custom neuron count */}
      <div className="header-content-wrapper" style={{ position: 'relative', zIndex: 1 }}>
        <div className="logo">
          <img src={process.env.PUBLIC_URL + '/jyeshta-logo.png'} alt="Jyeshta AI Logo" className="jyeshta-logo-img" />
          <div className="logo-text-container">
            <Typewriter speed={100} showCursor={showHeaderCursor} replay={inView}> {/* Pass replay */}
              Jyeshta <span className="logo-ai">A<span id="logo-ai-i">I</span></span>
            </Typewriter>
          </div>
        </div>
        <nav className="nav-links">
          <div className="nav-item">
            <a href="#who-we-are">Who we are</a>
            <span className="glitch-separator"></span>
          </div>
          <div className="nav-item">
            <a href="#what-we-do">What we do</a>
            <span className="glitch-separator"></span>
          </div>
          <div className="nav-item">
            <a href="#careers">Careers</a>
            <span className="glitch-separator"></span>
          </div>
          <div className="nav-item">
            <a href="#contact">Contact</a>
          </div>
        </nav>
      </div>
    </header>
  );
}); // Use React.forwardRef

export default Header;
